export const HORIZONTAL_POSITION = {
    LEFT: 'left',
    RIGHT: 'right',
};
export const VERTICAL_POSITION = {
    BOTTOM: 'bottom',
    TOP: 'top',
};
export const POSITION = {
    ...HORIZONTAL_POSITION,
    ...VERTICAL_POSITION,
};
export const SIZE = {
    LARGE: 'large',
    MEDIUM: 'medium',
    SMALL: 'small',
    XSMALL: 'xsmall',
};
export const WEIGHT = {
    BOLD: 'bold',
    REGULAR: 'regular',
};
export const BUTTON_TYPE = {
    BUTTON: 'button',
    RESET: 'reset',
    SUBMIT: 'submit',
};
export const BUTTON_AS_TYPE = {
    ANCHOR: 'a',
    BUTTON: 'button',
};
export const THEME = {
    DARK: 'dark',
    LIGHT: 'light',
};
export const VARIANT = {
    DESTRUCTIVE: 'destructive',
    PRIMARY: 'primary',
    SECONDARY: 'secondary',
    TERTIARY: 'tertiary',
};
export const BADGE_VARIANT = {
    DEFAULT: 'default',
    ERROR: 'error',
    PRIMARY: 'primary',
    SUCCESS: 'success',
    WARNING: 'warning',
};
export const DIRECTION = {
    DOWN: 'down',
    LEFT: 'left',
    RIGHT: 'right',
    UP: 'up',
};
export const INTENT = {
    ERROR: 'error',
    SUCCESS: 'success',
    WARNING: 'warning',
};
export const LOADING_VARIANT = {
    ARROW: 'arrow',
    SPINNER: 'spinner',
};
export const TYPOGRAPHY = {
    BUTTON_LARGE: 'button-large',
    BUTTON_REGULAR: 'button-regular',
    BUTTON_SMALL: 'button-small',
    CAPTION: 'caption',
    HEADING_1: 'heading1',
    HEADING_2: 'heading2',
    HEADING_3: 'heading3',
    HEADING_4: 'heading4',
    HEADING_5: 'heading5',
    HEADING_6: 'heading6',
    HEADING_7: 'heading7',
    HERO: 'hero',
    LARGE: 'large',
    LINK_LARGE: 'link-large',
    LINK_LARGE_BOLD: 'link-large-bold',
    LINK_REGULAR: 'link-regular',
    LINK_REGULAR_BOLD: 'link-regular-bold',
    LINK_SMALL: 'link-small',
    LINK_SMALL_BOLD: 'link-small-bold',
    REGULAR: 'regular',
    SMALL: 'small',
    VRM_LARGE: 'vrm-large',
    VRM_REGULAR: 'vrm-regular',
    VRM_SMALL: 'vrm-small',
    VRM_XSMALL: 'vrm-xsmall',
};
export const INFOBOX_VARIANT = {
    DEFAULT: 'default',
    ERROR: 'error',
    INFO: 'info',
    SUCCESS: 'success',
    WARNING: 'warning',
};
